export default __webpack_public_path__ + "static/media/print_estimate_shanai_1.928e2edf.svg";